
import { combineReducers } from 'redux';
import myTasks from 'store/reducers/myTasks/myTasks';
import myTasksFilters from 'store/reducers/myTasks/myTasksFilters';
import myTasksExcel from 'store/reducers/myTasks/myTasksExcel';

export default combineReducers({
  myTasks,
  myTasksFilters,
  myTasksExcel
});